import React, {useEffect, useState} from 'react';
import {View, Text, TextInput, Pressable} from 'react-native';
import {IAuthenticationService} from '../../Services/Interfaces/IAuthenticationService';
import AuthenticationService from '../../Services/AuthenticationService';
import Icon from '../Shared/Icon';
import {CommonStyleSheet} from '../../Styles/Shared/CommonStyles';
import Colors from '../../Styles/Shared/Colors';
import {ILogService} from '../../Services/Interfaces/ILogService';
import LogService from '../../Services/LogService';
import {ROLES} from '../../Constants/AppConstants';
import {ControlsStyleSheet} from '../../Styles/Shared/Controls';
import {AxiosRequestConfig} from 'axios';
import ApiService from '../../Services/ApiService';
import DynamicAutocomplete from '../DynamicControls/DynamicAutocomplete';
import {LabelValue, MongoIdSqlId} from '../../Types/DtoTypes';
import {ImpersonateStyleSheet} from '../../Styles/ImpersonateStyles';

type ImpersonateOrgProps = {impersonateCallback: () => void};
type OrgInfo = {
  orgId: number;
  orgName: string;
};

const ImpersonateOrg = (props: ImpersonateOrgProps): React.ReactElement => {
  const [orgId, setOrgId] = useState<string | null>();
  const [orgName, setOrgName] = useState('');
  const [orgList, setOrgList] = useState<LabelValue<string>[]>([]);
  const [selectedRole, setSelectedRole] = useState('');

  useEffect(() => {
    const callback = async () => {
      await getOrgs();
    };

    callback();
  }, []);
  useEffect(() => {}, [orgName]);

  const authService: IAuthenticationService = new AuthenticationService();
  const logService: ILogService = new LogService();
  const apiService = new ApiService(() => {});

  const impersonate = async () => {
    if (!selectedRole) return;

    let result = await authService.getImpersonateToken(parseInt(orgId!), [
      selectedRole,
    ]);
    props.impersonateCallback();
  };

  const getOrgs = async () => {
    let url = process.env.REACT_APP_ORGINFO_URL + '?featureCodeFilter=FORMS';
    let config: AxiosRequestConfig = {};
    config.method = 'GET';
    config.url = url;

    try {
      let response = await apiService.sendRequest<OrgInfo[]>(config);
      let mappedList: LabelValue<string>[] = response.data.map(x => ({
        label: x.orgName,
        value: JSON.stringify({
          mongoId: x.orgId.toString(),
          label: x.orgName,
          SQLServerId: x.orgId.toString(),
        }),
      }));
      setOrgList(mappedList);
    } catch (err) {
      await logService.sendLog(JSON.stringify(err));
    }
  };

  const orgIdChange = (value: string) => {
    if (isNaN(Number(value))) {
      setOrgId('');
      return;
    }

    setOrgId(value);
  };

  const orgSelected = (value: string) => {
    if (!value) {
      setOrgId(null);
      return;
    }

    let parsedValue: MongoIdSqlId = JSON.parse(value);
    setOrgId(parsedValue.SQLServerId!);
  };

  const renderRoles = () => {
    let roleControls = [];
    let roles: string[] = [
      ROLES.FIRS_ADMIN,
      ROLES.FIRS_BASIC,
      ROLES.FIRS_SUPERVISOR,
      ROLES.PROJECT_SAFETY_MANAGER,
      ROLES.SAFETY_ADMIN,
    ];

    for (let i = 0; i < roles.length; i++) {
      let roleName = roles[i];
      roleControls.push(
        <Pressable
          key={roleName}
          style={({pressed}) => [
            ImpersonateStyleSheet.roleContainer,
            {
              backgroundColor:
                roleName === selectedRole ? Colors.lightTeal : 'white',
            }, // Change background color
            pressed && {opacity: 0.8},
          ]}
          onPress={() => setSelectedRole(roleName)}>
          <View
            style={[
              ControlsStyleSheet.checkBox,
              roleName === selectedRole && {
                backgroundColor: Colors.teal,
                borderColor: Colors.teal,
              },
            ]}>
            <Icon
              icon={'checked'}
              color={
                roleName === selectedRole
                  ? Colors.white
                  : Colors.whiteTransparent
              }
              size={16}
            />
          </View>
          <View style={{marginLeft: 10}}>
            <Text
              style={[
                ControlsStyleSheet.checkBoxText,
                {
                  fontFamily: 'Lato',
                  fontSize: 16,
                },
              ]}>
              {roleName}
            </Text>
          </View>
        </Pressable>,
      );
    }

    return roleControls;
  };

  return (
    <View style={ImpersonateStyleSheet.container}>
      <Text style={ImpersonateStyleSheet.header}>Impersonate</Text>
      <View style={ImpersonateStyleSheet.form}>
        <DynamicAutocomplete
          config={{
            optionItems: orgList,
            optionFilter: orgName,
          }}
          label='Org Name'
          value={orgId?.toString()}
          onChange={(controlId, controlTypeId, value) => orgSelected(value)}
        />
        <Text style={ImpersonateStyleSheet.label}>Org ID</Text>
        <TextInput
          style={ImpersonateStyleSheet.input}
          value={orgId?.toString()}
          inputMode='numeric'
          onChangeText={newText => orgIdChange(newText)}
        />
        {renderRoles()}
        <Pressable
          style={({pressed}) => [
            CommonStyleSheet.greenButton,
            {alignSelf: 'center', marginTop: 0, marginBottom: 20},
            pressed && {
              opacity: 0.8,
            },
          ]}
          onPress={() => impersonate()}>
          <Text style={CommonStyleSheet.greenButtonText}>Impersonate</Text>
        </Pressable>
      </View>
    </View>
  );
};

export default ImpersonateOrg;
